import { Slider } from "@mui/material";
import { useState } from "react";

const Polls = () => {
  const [range, setRange] = useState({
    range1: 5,
    range2: 5,
    range3: 5,
    range4: 5,
    range5: 5,
  });
  const [rating, setRating] = useState(0);

  const rangeHandler = (event, key) => {
    const newValue = parseInt(event.target.value);
    setRange({
      ...range,
      [key]: newValue,
    });
  };

  const handleRatingClick = (newRating) => {
    setRating(newRating);
  };

  return (
    <>
      {/* <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
        <div className="col-auto">
          <h1 className="text-20 lh-14 fw-600">
            Help Us Improve: Share Your Honest Feedback
          </h1>
        </div>
        <div className="col-auto"></div>
      </div> */}
      <div className="py-30 px-30 rounded-16 bg-white shadow-2 pb-60">
        <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
          <div className="col-auto pl-45">
            <h1 className="text-20 lh-14 fw-600 text-primary">
              No Polls at this moment
            </h1>
          </div>
          {/* <div className="col-auto"></div> */}
        </div>
        {/* <div className="row y-gap-30 pl-30">
          <div className="col-12 pt-40">
            <h4 className="text-14 fw-600">
              Lorem ipsum dolor sit amet consectetur. Non lorem volutpat?
            </h4>
            <div className="range-container">
              <Slider
                id="range-1"
                value={range.range1}
                onChange={(e) => rangeHandler(e, "range1")}
                aria-label="Range Slider"
                min={0}
                max={10}
                style={{ width: "75%", height: "16px" }}
              />
              <label
                htmlFor="range-1"
                className="range-label"
                style={{
                  left: `calc(${(range.range1 / 10) * 75}% - 0px)`,
                  marginTop: "15px",
                }}
              >
                {range.range1}
              </label>
            </div>
          </div>
          <div className="col-12 pt-40">
            <h4 className="text-14 fw-600">
              Lorem ipsum dolor sit amet consectetur. Non lorem volutpat?
            </h4>
            <div className="range-container">
              <Slider
                id="range-2"
                value={range.range2}
                onChange={(e) => rangeHandler(e, "range2")}
                aria-label="Range Slider"
                min={0}
                max={10}
                style={{ width: "75%", height: "16px" }}
              />
              <label
                htmlFor="range-2"
                className="range-label"
                style={{
                  left: `calc(${(range.range2 / 10) * 75}% - 0px)`,
                  marginTop: "15px",
                }}
              >
                {range.range2}
              </label>
            </div>
          </div>
          <div className="col-12 pt-40">
            <h4 className="text-14 fw-600">
              Lorem ipsum dolor sit amet consectetur. Non lorem volutpat?
            </h4>
            <div className="range-container">
              <Slider
                id="range-3"
                value={range.range3}
                onChange={(e) => rangeHandler(e, "range3")}
                aria-label="Range Slider"
                min={0}
                max={10}
                style={{ width: "75%", height: "16px" }}
              />
              <label
                htmlFor="range-3"
                className="range-label"
                style={{
                  left: `calc(${(range.range3 / 10) * 75}% - 0px)`,
                  marginTop: "15px",
                }}
              >
                {range.range3}
              </label>
            </div>
          </div>
          <div className="col-12 pt-40">
            <h4 className="text-14 fw-600">
              Lorem ipsum dolor sit amet consectetur. Non lorem volutpat?
            </h4>
            <div className="range-container">
              <Slider
                id="range-4"
                value={range.range4}
                onChange={(e) => rangeHandler(e, "range4")}
                aria-label="Range Slider"
                min={0}
                max={10}
                style={{ width: "75%", height: "16px" }}
              />
              <label
                htmlFor="range-4"
                className="range-label"
                style={{
                  left: `calc(${(range.range4 / 10) * 75}% - 0px)`,
                  marginTop: "15px",
                }}
              >
                {range.range4}
              </label>
            </div>
          </div>
          <div className="col-12 pt-40">
            <h4 className="text-14 fw-600">
              Lorem ipsum dolor sit amet consectetur. Non lorem volutpat?
            </h4>
            <div className="range-container">
              <Slider
                id="range-5"
                value={range.range5}
                onChange={(e) => rangeHandler(e, "range5")}
                aria-label="Range Slider"
                min={0}
                max={10}
                style={{ width: "75%", height: "16px" }}
              />
              <label
                htmlFor="range-5"
                className="range-label"
                style={{
                  left: `calc(${(range.range5 / 10) * 75}% - 0px)`,
                  marginTop: "15px",
                }}
              >
                {range.range5}
              </label>
            </div>
          </div>
          <div className="col-12 pt-40">
            <h4 className="text-14 fw-600">
              Lorem ipsum dolor sit amet consectetur. Non lorem volutpat?
            </h4>
            <div className="d-flex x-gap-10 pt-20">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  className={`fa-star text-30 fw-200 ${
                    star <= rating ? "fas" : "far"
                  }`}
                  onClick={() => handleRatingClick(star)}
                ></i>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Polls;
